import FacebookIcon from '../../../assets/FacebookIcon';
import InstagramIcon from '../../../assets/InstagramIcon';
import YouTubeIcon from '../../../assets/YoutubeIcon';

export const getSocialMediaIconFromName = (iconName: string) => {
    switch (iconName) {
        case 'facebook':
            return <FacebookIcon />;
        case 'instagram':
            return <InstagramIcon />;
        case 'youtube':
            return <YouTubeIcon />;
        default:
            return null;
    }
};
